import type { SxProps, Theme } from "@mui/material/styles";

// The site's raised dark button look: used by Button, ButtonLink and ButtonLinkHref
export const buttonSx: SxProps<Theme> = {
    paddingX: 2,
    paddingY: 1,
    backgroundColor: "#4d4d4d",
    "&:hover": {
        backgroundColor: "#3d3d3d" // Slightly darker on hover
    },
    // Thick bottom border gives the "pressable 3D" look
    borderTop: "2px solid #2d2d2d",
    borderRight: "2px solid #2d2d2d",
    borderLeft: "2px solid #2d2d2d",
    borderBottom: "8px solid #2d2d2d",
    "&:active": {
        borderBottom: "4px solid #2d2d2d"
    },
    color: "#ffffff",
    fontSize: 16,
    textTransform: "none",
    borderRadius: "12px"
};